import { useTranslation } from "react-i18next"
import classes from "./Byname.module.css"

import adjective_CN from "../../assets/json/parameters/byname/Adjective_CNzh.json"
import adjective_DE from "../../assets/json/parameters/byname/Adjective_EUde_Masculine.json"
import adjective_EN from "../../assets/json/parameters/byname/Adjective_EUen.json"
import adjective_ES from "../../assets/json/parameters/byname/Adjective_EUes_Masculine.json"
import adjective_FR from "../../assets/json/parameters/byname/Adjective_EUfr_Masculine.json"
import adjective_IT from "../../assets/json/parameters/byname/Adjective_EUit_Masculine.json"
import adjective_NL from "../../assets/json/parameters/byname/Adjective_EUnl_Common.json"
import adjective_RU from "../../assets/json/parameters/byname/Adjective_EUru_Masculine.json"
import adjective_JP from "../../assets/json/parameters/byname/Adjective_JPja.json"
import adjective_KR from "../../assets/json/parameters/byname/Adjective_KRko.json"
import adjective_TW from "../../assets/json/parameters/byname/Adjective_TWzh.json"
import adjective_USEN from "../../assets/json/parameters/byname/Adjective_USen.json"
import adjective_USES from "../../assets/json/parameters/byname/Adjective_USes_Masculine.json"
import adjective_USFR from "../../assets/json/parameters/byname/Adjective_USfr_Masculine.json"

import subject_CN from "../../assets/json/parameters/byname/Subject_CNzh.json"
import subject_DE from "../../assets/json/parameters/byname/Subject_EUde.json"
import subject_EN from "../../assets/json/parameters/byname/Subject_EUen.json"
import subject_ES from "../../assets/json/parameters/byname/Subject_EUes.json"
import subject_FR from "../../assets/json/parameters/byname/Subject_EUfr.json"
import subject_IT from "../../assets/json/parameters/byname/Subject_EUit.json"
import subject_NL from "../../assets/json/parameters/byname/Subject_EUnl.json"
import subject_RU from "../../assets/json/parameters/byname/Subject_EUru.json"
import subject_JP from "../../assets/json/parameters/byname/Subject_JPja.json"
import subject_KR from "../../assets/json/parameters/byname/Subject_KRko.json"
import subject_TW from "../../assets/json/parameters/byname/Subject_TWzh.json"
import subject_USEN from "../../assets/json/parameters/byname/Subject_USen.json"
import subject_USES from "../../assets/json/parameters/byname/Subject_USes.json"
import subject_USFR from "../../assets/json/parameters/byname/Subject_USfr.json"

import Input from "../../components/UI/Input/Input"

import { bynameAdjectives, bynameSubjects } from "../../Utils"

const gender_regex = /\[group=00c9 type=0005 params=([0-9a-z ]+)\]/
const ruby_regex = /\[ruby="(.*?)"\](.*?)\[\/ruby\]/

function* matchAll(str, regexp) {
    const re = new RegExp(regexp, "g")
    let match
    while ((match = re.exec(str))) {
        yield match
    }
}

function parseHexString(str) {
    var result = []
    str = str.replaceAll(" ", "")
    while (str.length >= 2) {
        result.push(parseInt(str.substring(0, 2), 16))
        str = str.substring(2, str.length)
    }
    var res = []
    for (let i = 0; i < result.length; i += 2) {
        const num = result[i] + result[i + 1] * 256
        res.push(num)
    }
    return res
}

function convertToString(arr) {
    const res = []
    let i = 0
    while (i < arr.length) {
        const l = (arr[i] / 2) >>> 0
        i += 1
        const s = arr
            .slice(i, i + l)
            .map(a => String.fromCharCode(a))
            .join("")
        i += l
        res.push(s)
    }
    return res
}

function get_raw_string(t, num, adjective, form) {
    const key = adjective
        ? "translation:CommonMsg.Byname.BynameAdjective"
        : "translation:CommonMsg.Byname.BynameSubject"
    let res = t(`${key}.${num}`).replace("[group=00c9 type=0009 params=]", "")
    if (!adjective && res.includes("[group=0001 type=0002 params=")) {
        return null
    }
    if (!adjective) {
        res = res
            .replace("[group=00c9 type=0000 params=01 ff ff 00]", "")
            .replace("[group=00c9 type=0000 params=02 ff ff 00]", "")
            .replace("[group=00c9 type=0000 params=03 ff ff 00]", "")
            .replace("[group=00c9 type=0000 params=04 ff ff 00]", "")
    }
    const matches = Array.from(matchAll(res, gender_regex))
    if (matches.length > 0) {
        if (form === -1) {
            return null
        }
        let res_str = res
        for (let i = 0; i < matches.length; i++) {
            const p = convertToString(parseHexString(matches[i][1]))
            res_str = res_str.replace(matches[i][0], p[form])
        }
        return res_str
    }
    if (form !== -1 && adjective) {
        return null
    }
    const matches_ruby = Array.from(matchAll(res, ruby_regex))
    if (matches_ruby.length > 0) {
        let res_str = res
        for (let i = 0; i < matches_ruby.length; i++) {
            res_str = res_str.replace(matches_ruby[i][0], matches_ruby[i][2])
        }
        return res_str
    }
    return res
}

export const BynameString = props => {
    const { t } = useTranslation()

    const get_string = () => {
        const raw_string = get_raw_string(t, props.num, props.adjective, props.form)
        if (raw_string) {
            return <div className={classes.BynameEntry}>{raw_string}</div>
        }
    }
    return get_string()
}

export const BynameAdjectiveString = props => {
    const [t, i18n] = useTranslation()

    const get_full_str = () => {
        switch (i18n.language) {
            case "zh-CN":
            case "zh-TW":
            case "jp":
            case "kr":
            case "en":
            case "en-US":
                return <BynameString num={props.num} adjective={true} form={-1} />
            case "es":
            case "fr":
            case "it":
            case "es-MX":
            case "fr-US":
                return (
                    <>
                        <BynameString num={props.num} adjective={true} form={-1} />
                        <BynameString num={props.num} adjective={true} form={0} />
                        <BynameString num={props.num} adjective={true} form={1} />
                    </>
                )

            case "de":
            case "ru":
                return (
                    <>
                        <BynameString num={props.num} adjective={true} form={-1} />
                        <BynameString num={props.num} adjective={true} form={0} />
                        <BynameString num={props.num} adjective={true} form={1} />
                        <BynameString num={props.num} adjective={true} form={2} />
                    </>
                )

            case "nl":
                return (
                    <>
                        <BynameString num={props.num} adjective={true} form={-1} />
                        <BynameString num={props.num} adjective={true} form={2} />
                        <BynameString num={props.num} adjective={true} form={3} />
                    </>
                )
            default:
                return <BynameString num={props.num} adjective={true} form={-1} />
        }
    }
    return (
        <div className={classes.ByamlFullEntry}>
            {props.formless ? null : (
                <Input
                    type="checkbox"
                    title={t("translation:LayoutMsg.Cmn_CstBase_00.L_BtnList_08-T_SoldOut_00")}
                    val={props.owned}
                    labelClick={true}
                    changed={() => props.store(props.num)}
                />
            )}
            {get_full_str()}
        </div>
    )
}

export const BynameSubjectString = props => {
    const [t] = useTranslation()
    const get_full_str = () => {
        return (
            <>
                <BynameString num={props.num + "_0"} adjective={false} form={0} />
                <BynameString num={props.num + "_1"} adjective={false} form={1} />
            </>
        )
    }
    return (
        <div className={classes.ByamlFullEntry}>
            {props.formless ? null : (
                <Input
                    type="checkbox"
                    title={t("translation:LayoutMsg.Cmn_CstBase_00.L_BtnList_08-T_SoldOut_00")}
                    val={props.owned}
                    labelClick={true}
                    changed={() => props.store(props.num)}
                />
            )}
            {get_full_str()}
        </div>
    )
}

export const BynameAdjectiveList = props => {
    const [, i18n] = useTranslation()

    const get_list = () => {
        switch (i18n.language) {
            case "zh-CN":
                return adjective_CN.Labels
            case "zh-TW":
                return adjective_TW.Labels
            case "jp":
                return adjective_JP.Labels
            case "kr":
                return adjective_KR.Labels
            case "en":
                return adjective_EN.Labels
            case "en-US":
                return adjective_USEN.Labels
            case "es":
                return adjective_ES.Labels
            case "fr":
                return adjective_FR.Labels
            case "it":
                return adjective_IT.Labels
            case "es-MX":
                return adjective_USES.Labels
            case "fr-US":
                return adjective_USFR.Labels
            case "de":
                return adjective_DE.Labels
            case "ru":
                return adjective_RU.Labels
            case "nl":
                return adjective_NL.Labels
            default:
                return adjective_EN.Labels
        }
    }
    return get_list()
        .filter(
            k => bynameAdjectives.includes(parseInt(k)) && (!(props.showOnlyOwned ?? false) || props.owned[parseInt(k)])
        )
        .map((k, v) => (
            <BynameAdjectiveString store={props.store} num={k} key={v} owned={props.owned[parseInt(k)] ?? false} />
        ))
}

export const BynameSubjectList = props => {
    const [, i18n] = useTranslation()

    const get_list = () => {
        switch (i18n.language) {
            case "zh-CN":
                return subject_CN.Labels
            case "zh-TW":
                return subject_TW.Labels
            case "jp":
                return subject_JP.Labels
            case "kr":
                return subject_KR.Labels
            case "en":
                return subject_EN.Labels
            case "en-US":
                return subject_USEN.Labels
            case "es":
                return subject_ES.Labels
            case "fr":
                return subject_FR.Labels
            case "it":
                return subject_IT.Labels
            case "es-MX":
                return subject_USES.Labels
            case "fr-US":
                return subject_USFR.Labels
            case "de":
                return subject_DE.Labels
            case "ru":
                return subject_RU.Labels
            case "nl":
                return subject_NL.Labels
            default:
                return subject_EN.Labels
        }
    }
    return get_list()
        .filter(
            k =>
                bynameSubjects.includes(parseInt(k)) &&
                !k.includes("_1") &&
                (!(props.showOnlyOwned ?? false) || props.owned[parseInt(k)])
        )
        .map((k, v) => (
            <BynameSubjectString
                store={props.store}
                num={k.replace("_0", "")}
                key={v}
                owned={props.owned[parseInt(k)] ?? false}
            />
        ))
}

export const get_byname_adj_list = (t, i18n, owned) => {
    const get_list = () => {
        switch (i18n.language) {
            case "zh-CN":
                return adjective_CN.Labels
            case "zh-TW":
                return adjective_TW.Labels
            case "jp":
                return adjective_JP.Labels
            case "kr":
                return adjective_KR.Labels
            case "en":
                return adjective_EN.Labels
            case "en-US":
                return adjective_USEN.Labels
            case "es":
                return adjective_ES.Labels
            case "fr":
                return adjective_FR.Labels
            case "it":
                return adjective_IT.Labels
            case "es-MX":
                return adjective_USES.Labels
            case "fr-US":
                return adjective_USFR.Labels
            case "de":
                return adjective_DE.Labels
            case "ru":
                return adjective_RU.Labels
            case "nl":
                return adjective_NL.Labels
            default:
                return adjective_EN.Labels
        }
    }

    const get_str = num => {
        switch (i18n.language) {
            case "zh-CN":
            case "zh-TW":
            case "jp":
            case "kr":
            case "en":
            case "en-US":
                return get_raw_string(t, num, true, -1)
            case "es":
            case "fr":
            case "it":
            case "es-MX":
            case "fr-US":
            case "de":
            case "ru":
                const raw_str = get_raw_string(t, num, true, -1)
                if (raw_str) return raw_str
                return get_raw_string(t, num, true, 0)
            case "nl":
                const raw_string = get_raw_string(t, num, true, -1)
                if (raw_string) return raw_string
                return get_raw_string(t, num, true, 2)
            default:
                return get_raw_string(t, num, true, -1)
        }
    }

    return get_list()
        .filter(k => bynameAdjectives.includes(parseInt(k)) && !(owned[parseInt(k)] ?? false))
        .map((k, v) => {
            return {
                value: v,
                label: get_str(k),
                raw: k,
            }
        })
}

export const get_byname_sub_list = (t, i18n, owned) => {
    const get_list = () => {
        switch (i18n.language) {
            case "zh-CN":
                return subject_CN.Labels
            case "zh-TW":
                return subject_TW.Labels
            case "jp":
                return subject_JP.Labels
            case "kr":
                return subject_KR.Labels
            case "en":
                return subject_EN.Labels
            case "en-US":
                return subject_USEN.Labels
            case "es":
                return subject_ES.Labels
            case "fr":
                return subject_FR.Labels
            case "it":
                return subject_IT.Labels
            case "es-MX":
                return subject_USES.Labels
            case "fr-US":
                return subject_USFR.Labels
            case "de":
                return subject_DE.Labels
            case "ru":
                return subject_RU.Labels
            case "nl":
                return subject_NL.Labels
            default:
                return subject_EN.Labels
        }
    }

    const get_str = num => {
        return get_raw_string(t, num, false, 0)
    }

    return get_list()
        .filter(k => bynameSubjects.includes(parseInt(k)) && !k.includes("_1") && !(owned[parseInt(k)] ?? false))
        .map((k, v) => {
            return {
                value: v,
                label: get_str(k),
                raw: k,
            }
        })
}
